module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kyoto-1-6b4071e3bc08e5e65e559312d1a1a4ac.png";